export const initialState = {
  policyModalOpen: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_POLICY_MODAL":
      return {
        ...state,
        policyModalOpen: action.policyModalOpen,
      };
    default:
      return state;
  }
};
export default reducer;
